export const TOGGLE_NAV_INVERSE = 'TOGGLE_NAV_INVERSE';
export const TOGGLE_NAV_OPACITY = 'TOGGLE_NAV_OPACITY';



// WEBPACK FOOTER //
// ./src/store/action-types.js